import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { useGetNotices } from "hooks/common/useGetNotices";
import speaker from "assets/banner/speaker_white.png";
import { ReactComponent as RightArrow } from "assets/morning/icon/rightArrow.svg";

type VerticalSlideMenuProps = { type: string; className?: string };

export default function VerticalSlideMenu({ type, className }: VerticalSlideMenuProps) {
    const style = twMerge("absolute bottom-0 w-full h-[60px] bg-[rgba(21,34,65,0.75)] responsive1200:h-[72px]", className);
    const slideContainerRef = useRef<HTMLDivElement | null>(null);
    const searchForm = {
        category: type,
        search: "subject",
        searchtxt: "",
        page: 1,
        limit: 10,
        notice: 1 as const,
    };
    const { data } = useGetNotices(searchForm);

    const slideUp = (target: HTMLDivElement | null) => {
        // const target = slideContainerRef.current;
        if (!target) return;

        const firstItem = target.querySelector("a") || target.querySelector("div");
        const height = firstItem?.offsetHeight;

        // 애니메니션 실행
        const animation = target.animate(
            [
                {
                    transform: "translateY(0px)",
                },
                {
                    transform: `translateY(-${height}px)`,
                },
            ],
            {
                duration: 400,
                easing: "ease-in-out",
            },
        );

        animation.onfinish = () => {
            if (firstItem) {
                target?.appendChild(firstItem); // 제일 위 항목을 맨 아래로 이동
            }
            target.style.transform = "translateY(0px)"; // 위치 초기화
        };
    };

    // 공지사항 슬라이드
    useEffect(() => {
        // 2개 이상일 때만 슬라이드
        if (data && data.data_list.length <= 1) return;
        
        const interval = setInterval(() => {
            slideUp(slideContainerRef.current);
        }, 3000);

        return () => clearInterval(interval);
    }, [data]);

    return (
        <div className={style}>
            <div className="max-w-[1200px] flex mx-auto h-full responsive1200:px-0 border-white/50 border-x responsive1200:border-x-0">
                <div className="flex-1 text-white flex items-center justify-center relative z-[11] border-r border-white/20 overflow-hidden px-5 responsive1200:border-r-0 responsive1200:px-[10px]">
                    <div className="w-full flex justify-between flex-1 items-center gap-[40px] responsive1200:flex-col responsive1200:items-start responsive1200:gap-0">
                        <div className="flex items-center gap-[10px] cursor-default text-nowrap shrink-0">
                            <img src={speaker} alt="" />
                            공지사항
                        </div>
                        <div className="flex-1 w-full h-[60px] overflow-hidden responsive1200:flex-none responsive1200:h-[40px]">
                            {data && data?.data_list.length > 0 ? (
                                <div ref={slideContainerRef}>
                                    {data.data_list.map((item, index) => {
                                        return (
                                            <Link
                                                to={`/support/notices/${item.list_no}`}
                                                key={index}
                                                className="h-[60px] text-[14px] text-white/50 mx-[40px] hover:underline flex items-center responsive1200:mx-0 responsive1200:h-[40px]"
                                            >
                                                <p className="truncate">{item.subject}</p>
                                            </Link>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="h-[60px] text-[14px] text-white/50 mx-[40px] flex items-center justify-center truncate cursor-default responsive1200:h-[40px] responsive1200:mx-0">
                                    등록된 게시글이 없습니다.
                                </div>
                            )}
                        </div>
                        <Link to="/support/notices" className="responsive1200:hidden">
                            <RightArrow />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
